import React, { useState } from "react";
import { Plus } from "lucide-react";
import { useApp } from "../../context/AppContext";
import { PATHWAY_COLORS } from "../../constants/pathwayDefaults";
import { FONT_SIZES, FONT_FAMILY, ICON_SIZES } from "../../constants/appConfig";
import { ActionButton } from "../ui/ActionButton";
import { FormInput } from "../ui/FormControls";

export const PathwayAdder = () => {
  const { palette, pathways, addPathway, showMessage } = useApp();
  const [name, setName] = useState("");
  const [color, setColor] = useState(PATHWAY_COLORS[0]);
  const [showForm, setShowForm] = useState(false);

  const handleAdd = async () => {
    const trimmed = name.trim();
    if (!trimmed) return;
    const id = trimmed
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/-+$/, "");
    if (pathways.find((p) => p.id === id)) {
      showMessage("A pathway with this name already exists", "error");
      return;
    }
    await addPathway({ id, name: trimmed, color, sortOrder: pathways.length });
    setName("");
    setColor(PATHWAY_COLORS[0]);
    setShowForm(false);
  };

  if (!showForm) {
    return (
      <button
        onClick={() => setShowForm(true)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          padding: "10px 16px",
          borderRadius: 8,
          border: `2px dashed ${palette.cardBorder}`,
          background: "transparent",
          color: palette.accent1,
          width: "100%",
          fontSize: FONT_SIZES.sm,
          fontWeight: 600,
          fontFamily: FONT_FAMILY,
          cursor: "pointer",
          transition: "all 0.2s",
          justifyContent: "center",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.borderColor = palette.accent1;
          e.currentTarget.style.background = `${palette.accent1}06`;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.borderColor = palette.cardBorder;
          e.currentTarget.style.background = "transparent";
        }}
      >
        <Plus size={ICON_SIZES.sm} />
        Add Pathway
      </button>
    );
  }

  return (
    <div
      style={{
        padding: 14,
        borderRadius: 8,
        border: `1px solid ${palette.accent1}`,
        background: `${palette.accent1}04`,
      }}
    >
      <div style={{ marginBottom: 12 }}>
        <FormInput
          label="Pathway Name"
          value={name}
          onChange={setName}
          placeholder="e.g. Advocate, Prospect, Lapsed..."
        />
      </div>
      <div>
        <label
          style={{
            fontSize: FONT_SIZES.xs,
            fontWeight: 600,
            color: palette.text2,
            display: "block",
            marginBottom: 6,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
          }}
        >
          Color
        </label>
        <div
          style={{
            display: "flex",
            gap: 6,
            flexWrap: "wrap",
            marginBottom: 14,
          }}
        >
          {PATHWAY_COLORS.map((c) => (
            <button
              key={c}
              onClick={() => setColor(c)}
              style={{
                width: 28,
                height: 28,
                borderRadius: 6,
                border:
                  color === c ? "3px solid #1e293b" : "2px solid transparent",
                background: c,
                cursor: "pointer",
                transition: "all 0.15s",
                boxShadow: color === c ? `0 0 0 2px ${c}40` : "none",
              }}
            />
          ))}
        </div>
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <ActionButton
          label="Cancel"
          variant="secondary"
          small
          onClick={() => {
            setShowForm(false);
            setName("");
          }}
        />
        <ActionButton label="Add" icon={Plus} small onClick={handleAdd} />
      </div>
    </div>
  );
};
